<template>
  <div id="user" style="min-width:1680px;">
    <el-container class="container" :style="{height:containerHeight}">
      <el-main class="main">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/user/service' }">我的服务</el-breadcrumb-item>
          <el-breadcrumb-item>服务记录</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="main-in">
          <p>
            <span style="margin-right: 48px;">
              <span class="key">状态：</span>
              <el-select v-model="select" placeholder="请选择">
                <el-option label="全部" value="1"></el-option>
                <el-option label="未处理" value="2"></el-option>
                <el-option label="处理中" value="3"></el-option>
                <el-option label="已完成" value="4"></el-option>
              </el-select>
            </span>
            <span style="margin-right: 48px;">
              <span class="key">项目名称：</span>
              <el-input v-model="input" placeholder="请输入"></el-input>
            </span>
            <span style="margin-right: 48px;">
              <span class="key">时间：</span>
              <el-date-picker v-model="time" type="daterange" range-separator="⇀"
                start-placeholder="开始日期" end-placeholder="结束日期" clear-icon="false">
              </el-date-picker>
            </span>
            <a class="tab-programme-a" href=""
              @click="routerNewsMore('/')">查询</a>
          </p>
          <div class="table">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{
background:'#FAFAFA',color:'#333333' }" :cell-style='cellStyle'>
              <el-table-column prop="number" label="编号" width="196" type="index">
              </el-table-column>
              <el-table-column prop="project" label="服务项目" width="196">
              </el-table-column>
              <el-table-column prop="contract" label="合同编号">
              </el-table-column>
              <el-table-column prop="quantity" label="产品数量" width="196" type="index">
              </el-table-column>
              <el-table-column prop="state" label="状态" width="196">
                <template #default="{row}">
                  <el-badge is-dot :type="formateSate(row.state)"
                    style="line-height: 8px;margin-right: 8px;">
                  </el-badge>{{row.state}}
                </template>
              </el-table-column>
              <el-table-column prop="term" label="服务期限">
              </el-table-column>
              <el-table-column prop="person" label="负责人" width="196">
              </el-table-column>
              <el-table-column prop="operation" label="操作" width="196">
                <template #default="scope">
                  <span @click="alert(scope)">详情</span>
                </template>
              </el-table-column>
            </el-table>
            <el-dialog :lock-scroll="false" v-if="dialogVisible" title="详情"
              :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
              :close-on-press-escape="false" @close="ruleForm.textarea=''">
              <template v-if="state==='untreated'">
                <div class="dialog">
                  <div style="margin-bottom: 16px">
                    <span style="margin-right: 165px;">
                      <span class="key">服务项目：</span>
                      <span class="value">DGX A800</span>
                    </span>
                    <span>
                      <span class="key">合同编号：</span>
                      <span class="value">SSH 登录</span>
                    </span>
                  </div>
                  <div style="margin-bottom: 16px;">
                    <span style="margin-right: 197px;">
                      <span class="key">产品数量：</span>
                      <span class="value">10台</span>
                    </span>
                    <span>
                      <span class="key">服务期限：</span>
                      <span class="value">2021/1/1--2030/1/1</span>
                    </span>
                  </div>
                  <div style="margin-bottom: 16px">
                    <span class="key">状态：</span>
                    <span class="state">未处理</span>
                  </div>
                  <div style="margin-top: 24px;">
                    <span class="key">预约详情：</span>
                    <div class="details value">
                      NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                      平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型
                    </div>
                  </div>
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button type="success" @click="handleCancel" size="small">取消预约</el-button>
                </span>
              </template>
              <template v-else-if="state==='processing'">
                <div class="dialog">
                  <div style="margin-bottom: 16px">
                    <span style="margin-right: 165px;">
                      <span class="key">服务项目：</span>
                      <span class="value">DGX A800</span>
                    </span>
                    <span>
                      <span class="key">合同编号：</span>
                      <span class="value">SSH 登录</span>
                    </span>
                  </div>
                  <div style="margin-bottom: 16px;">
                    <span style="margin-right: 197px;">
                      <span class="key">产品数量：</span>
                      <span class="value">10台</span>
                    </span>
                    <span>
                      <span class="key">服务期限：</span>
                      <span class="value">2021/1/1--2030/1/1</span>
                    </span>
                  </div>
                  <div style="margin-bottom: 16px">
                    <span style="margin-right: 214px;">
                      <span class="key">状态：</span>
                      <span class="state">处理中</span>
                    </span>
                    <span>
                      <span class="key">负责人：</span>
                      <span class="value">于维</span>
                    </span>
                  </div>
                  <div style="margin-top: 24px;">
                    <span class="key">预约详情：</span>
                    <div class="details value">
                      NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                      平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型
                    </div>
                  </div>
                  <div style="margin-top: 16px;">
                    <span class="key">回复：</span>
                    <div class=" reply value">
                      NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                      平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型
                    </div>
                  </div>
                  <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                    <el-form-item label="咨询：" prop="textarea">
                      <el-input type="textarea" v-model="ruleForm.textarea" placeholder="请输入"
                        resize="none" style=""></el-input>
                    </el-form-item>
                  </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="handleComplete" size="small">完成</el-button>
                  <el-button type="success" @click="handleSend" size="small">发送</el-button>
                </span>
              </template>
              <template v-else>
                <div class="dialog">
                  <div style="margin-bottom: 16px">
                    <span style="margin-right: 165px;">
                      <span class="key">服务项目：</span>
                      <span class="value">DGX A800</span>
                    </span>
                    <span>
                      <span class="key">合同编号：</span>
                      <span class="value">SSH 登录</span>
                    </span>
                  </div>
                  <div style="margin-bottom: 16px;">
                    <span style="margin-right: 197px;">
                      <span class="key">产品数量：</span>
                      <span class="value">10台</span>
                    </span>
                    <span>
                      <span class="key">服务期限：</span>
                      <span class="value">2021/1/1--2030/1/1</span>
                    </span>
                  </div>
                  <div style="margin-bottom: 16px">
                    <span style="margin-right: 214px;">
                      <span class="key">状态：</span>
                      <span class="state">已完成</span>
                    </span>
                    <span>
                      <span class="key">负责人：</span>
                      <span class="value">于维</span>
                    </span>
                  </div>
                  <div style="margin-top: 24px;">
                    <span class="key">预约详情：</span>
                    <div class="details value">
                      NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                      平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型
                    </div>
                  </div>
                  <div style="margin-top: 16px;">
                    <span class="key">回复：</span>
                    <div class=" reply value">
                      NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                      平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型
                    </div>
                  </div>
                </div>
              </template>
            </el-dialog>
            <div class="pagination">
              <el-pagination style="text-align:right" background layout="prev, pager, next"
                :total="1000">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "User",
  data () {
    var validateText = (rule, value, callback) => {
      if (value === '') {
        callback('请输入预约详情')
      } else {
        callback()
      }
    }
    return {
      nowIndex: null,
      select: '1',
      input: '',
      time: '',
      dialogVisible: false,
      state: '',
      containerHeight:null,
      ruleForm: {
        textarea: '',
      },
      rules: {
        textarea: [
          { validator: validateText, trigger: 'blur' }
        ]
      },
      tableData: [
        {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '未处理',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        },
        {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '未处理',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '处理中',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          state: '已完成',
          term: '2021/10/01 - 2022/10/01',
          person: '于维',
          operation: '详情'
        },
      ]
    }
  },
  created(){
    this.containerHeight = document.body.clientHeight - 104 + 'px'
  },
  methods: {
    handleSend () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          alert('111')
        } else {
          alert('222')
        }
      })
    },
    alert (scope) {
      this.nowIndex = scope.$index
      this.dialogVisible = true
      if (scope.row.state === '未处理') {
        this.state = 'untreated'
      } else if (scope.row.state === '处理中') {
        this.state = 'processing'
      } else {
        this.state = 'completed'
      }
    },
    handleClose () {
      this.dialogVisible = false
    },
    handleCancel () {
      this.dialogVisible = false
    },
    handleComplete () {
      this.state = 'completed'
      let obj = this.tableData[this.nowIndex]
      this.$set(obj, 'state', '已完成')
      this.dialogVisible = false
    },
    // 单元格的 style 的回调方法
    cellStyle ({ columnIndex }) {
      if (columnIndex === 7) {
        return `color: #77BA00;`
      } else {
        return ''
      }
    },
    formateSate (state) {
      let nowState
      switch (state) {
        case '未读':
          nowState = 'success'
          break
        case '未处理':
          nowState = 'danger'
          break
        case '处理中':
          nowState = 'primary'
          break
        case '已完成':
          nowState = 'info'
          break
      }
      return nowState

    }
  }
}
</script>

<style scoped>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.main {
  padding-top: 4px;
}

::v-deep .el-breadcrumb__inner {
  color: #999999 !important;
  font-size: 16px;
  font-weight: 400 !important;
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #333333 !important;
}
.key {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}
::v-deep .el-input__inner {
  width: 224px;
  height: 32px;
  border-radius: 0;
}
::v-deep .el-input__suffix {
  top: 15%;
}
.el-input {
  width: 70%;
}
.el-range-editor.el-input__inner {
  padding: 0;
  width: 256px;
}
::v-deep .el-date-editor .el-range-separator {
  color: rgba(0, 0, 0, 0.25);
}
::v-deep .el-date-editor .el-range__icon {
  position: absolute;
  top: 0;
  right: 5px;
}
.tab-programme-a {
  margin-top: 0px !important;
  width: 70px;
  height: 32px;
  line-height: 32px;
}
.container {
  background-color: #f5f5f5;
}
.main-in {
  margin-top: 24px;
  background-color: #fff;
  padding: 24px 28px 24px 24px;
}
.main-in p {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 29px;
  display: flex;
  align-items: center;
}
.table /deep/tbody tr:hover > td {
  cursor: pointer;
  background-color: #fafafa;
}
.dialog {
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  margin-top: 15px;
  padding: 24px;
}
::v-deep .el-dialog__title {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
.key {
  color: #666666;
  font-size: 14px;
}
.value {
  color: #333333;
  font-size: 14px;
  line-height: 22px;
}
.state {
  color: #77ba00;
  font-size: 14px;
}
.details {
  border: 1px solid #d9d9d9;
  margin-top: 12px;
  padding: 4px 14px 0 12px;
}
.reply {
  margin-top: 12px;
  background: #f6f8fb;
  padding: 4px 18px 4px 15px;
}
::v-deep .el-textarea__inner {
  border-radius: 0;
}
::v-deep .el-textarea__inner::placeholder {
  color: #999999;
  font-size: 14px;
}
.el-form-item {
  margin-bottom: 0px;
}
::v-deep .el-dialog__footer {
  padding: 15px 24px 17px 0;
}
.el-button {
  border-radius: 0;
}
.el-button--success {
  color: #fff;
  background-color: #77ba00;
  border-color: #77ba00;
}
.el-button--success:hover {
  background-color: #77ba00;
}
.el-button--default:hover {
  background-color: #fff;
  color: #666666;
  border: 1px solid #dddddd;
}
.pagination {
  margin-top: 24px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #77ba00;
  border: none;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #606266;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled) {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
::v-deep .el-pagination button {
  background-color: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
::v-deep .el-dialog__close:hover {
  color: #77ba00 !important;
}
#user ::v-deep .el-dialog {
  min-width:576px;
  margin: 0 auto 0px;
}
</style>
